/**
 * The single wire→domain boundary cast for Rush Mid. The generated HTTP client returns the
 * swagger `RushMidSnapshot` (a flat, all-optional interface); the app consumes the shared
 * `@cs-shot/battle-sim` `RushMidSnapshot` discriminated union the backend actually built the
 * body from. One assertion here types the whole tree — so there are no per-field casts
 * downstream. Kept OUTSIDE `src/components/RushMid/**` so the module's no-assertion lint gate
 * stays honest: this is the ONE place the boundary is crossed.
 */
import type { RushMidSnapshot, RushMidSpectateView } from '@cs-shot/battle-sim';

export function toDomainSnapshot(raw: unknown): RushMidSnapshot {
  return (raw ?? { status: 'NONE' }) as RushMidSnapshot;
}

/** The read-only spectator view (watch endpoint). Nullable where the snapshot cast isn't: a
 *  match retiring mid-poll answers with a null body instead of a 404, and a spectate view has
 *  no neutral NONE state to default to — callers fold the null into their «match over» path. */
export function toSpectateView(raw: unknown): RushMidSpectateView | null {
  return (raw ?? null) as RushMidSpectateView | null;
}
